export const changeLoanIDReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_LoanID":
      return action.payload.LoanID;
    default:
      return state;
  }
};
